interface SatisfiesTickIconProps {
  /** Optional SVG width in pixels. */
  width?: string;
  /** Optional SVG height in pixels. */
  height?: string;
}

/** Light mint circle fill matching the Answer Assessment design. */
const CIRCLE_FILL = "#D6F5EE";

/** Dark teal checkmark stroke matching the Answer Assessment design. */
const CHECK_STROKE = "#0A6B5C";

/**
 * Filled mint circle with a dark teal checkmark for Satisfies verdicts.
 *
 * @param width - Optional SVG width
 * @param height - Optional SVG height
 * @returns SVG markup for the Satisfies tick icon
 */
const SatisfiesTickIcon = ({
  width = "20",
  height = "20",
}: SatisfiesTickIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="12" fill={CIRCLE_FILL} />
      <path
        d="M7.5 12.5L10.5 15.5L16.5 9"
        stroke={CHECK_STROKE}
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SatisfiesTickIcon;
